import type { ComponentProps } from 'react';
import React from 'react';
import { Button } from '@skin-seoul/design-system';
import { LucideIcon } from '@skin-seoul/shared-components';
import { useCartService } from '@skin-seoul/service';
import { useRegionCurrency } from '@skin-seoul/service';
import { useMutationLoading } from '@skin-seoul/utils';
import { CART_QUERY_KEYS } from '@skin-seoul/service';
type DirectAddToCartProps = {
  sku: string;
  onTrackAddToCart?: () => void;
} & ComponentProps<typeof Button>;
const DirectAddToCart = ({
  sku,
  onTrackAddToCart,
  ...props
}: DirectAddToCartProps) => {
  const {
    useAddToCart
  } = useCartService();
  const {
    currency
  } = useRegionCurrency();
  const {
    mutate: addToCart
  } = useAddToCart({
    currency
  });
  const isCartLoading = useMutationLoading(CART_QUERY_KEYS.default());
  const handleAddToCart = () => {
    if (!sku) {
      return;
    }
    addToCart({
      sku,
      quantity: 1,
      currency
    });
    onTrackAddToCart?.();
  };
  return <Button onClick={e => {
    e.stopPropagation();
    e.preventDefault();
    handleAddToCart();
  }} height="32px" width="32px" tablet={{
    width: '40px',
    height: '40px',
    borderRadius: '20px'
  }} minWidth="32px" bg="primary.400" color="white" borderRadius="16px" position="absolute" bottom={0} right={0} p={0} boxShadow="0 4px 4px 0 rgba(111, 63, 215, 0.25)" disabled={isCartLoading} {...props} data-sentry-element="Button" data-sentry-component="DirectAddToCart" data-sentry-source-file="DirectAddToCart.tsx">
      <LucideIcon boxSize={5} name="Plus" color="white" data-sentry-element="LucideIcon" data-sentry-source-file="DirectAddToCart.tsx" />
    </Button>;
};
export default DirectAddToCart;